import React from 'react';
import styled from 'styled-components';
import { mq } from '@kvdbil/components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background.light};
`;

const Inner = styled.div`
  width: 100%;
  max-width: 1100px;
  ${mq(null, 'laptop')} {
    max-width: 100vw;
    width: 100%;
  }
  ${mq(null, 'mobileL')} {
    max-width: 450px;
    margin: auto;
    width: 100%;
  }
`;

export interface WrapperProps {
  children: React.ReactNode;
}

const Wrapper = ({ children }: WrapperProps) => {
  return (
    <Container>
      <Inner>{children}</Inner>
    </Container>
  );
};

export default Wrapper;
